import { isEmpty } from 'lodash'
import { Dispatch } from 'redux'
import { getCRMAuth } from '../../api/crm'
import { actionTypeWrapper } from '../../utils/actionTypeWrapper'
import { errorLogger } from '../../utils/errorLogger'
import { hasNotEmptyProps } from '../../utils/object'
import type { FormData } from '../crmAuth/crmConnectionActions'

type MappingKeysPayload = {
  key: string
  value: string
  parentTable: string
  dataType: string
}

const setKeyValueMapping = (payload: Partial<MappingKeysPayload>) => ({
  type: 'SET_MAPPING_KEY_VALUE' as const,
  payload,
})

const updateKeyValueMapping = (
  objectType: string,
  payload: Partial<MappingKeysPayload>
) => actionTypeWrapper(objectType, setKeyValueMapping(payload))

export const getMappingValues =
  (crmId: string) =>
  async (
    dispatch: Dispatch,
    getState: () => {
      CRMAuth?: { crmFormData?: FormData }
      [key: string]: unknown
    }
  ) => {
    try {
      const crmFormData = getState().CRMAuth?.crmFormData

      if (
        !isEmpty(crmFormData) &&
        hasNotEmptyProps([
          'ace_syncable_lead_field_key',
          'ace_syncable_lead_field_value',
          'ace_syncable_opp_field_key',
          'ace_syncable_opp_field_value',
        ])(crmFormData as unknown as Record<string, unknown>)
      ) {
        dispatch(
          updateKeyValueMapping('lead', {
            key: crmFormData?.ace_syncable_lead_field_key || '',
            value: crmFormData?.ace_syncable_lead_field_value || '',
            parentTable: crmFormData?.ace_syncable_lead_parent_table || '',
            dataType: crmFormData?.ace_syncable_lead_field_data_type || '',
          })
        )
        dispatch(
          updateKeyValueMapping('opportunity', {
            key: crmFormData?.ace_syncable_opp_field_key || '',
            value: crmFormData?.ace_syncable_opp_field_value || '',
            parentTable: crmFormData?.ace_syncable_opp_parent_table || '',
            dataType: crmFormData?.ace_syncable_opp_field_data_type || '',
          })
        )
      } else {
        const { data } = await getCRMAuth(crmId)

        const crmData = data as FormData
        dispatch(
          updateKeyValueMapping('lead', {
            key: crmData?.ace_syncable_lead_field_key || '',
            value: crmData?.ace_syncable_lead_field_value || '',
            parentTable: crmData?.ace_syncable_lead_parent_table || '',
            dataType: crmData?.ace_syncable_lead_field_data_type || '',
          })
        )

        dispatch(
          updateKeyValueMapping('opportunity', {
            key: crmData?.ace_syncable_opp_field_key || '',
            value: crmData?.ace_syncable_opp_field_value || '',
            parentTable: crmData?.ace_syncable_opp_parent_table || '',
            dataType: crmData?.ace_syncable_opp_field_data_type || '',
          })
        )
      }
    } catch (error) {
      console.error(error)
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    }
  }
